import APIClient from './index';
import _ from 'lodash';

export const fetchAdminScopes = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('AdminScopes')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateAdminScopes = (User_id, scopes) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`AdminScopes/${User_id}`, { scopes })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const removeAdminAccess = User_id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`AdminScopes/${User_id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const fetchAvailableScopes = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('AdminScopes/available')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
